export interface IExceptionWithOriginalError {
  originalError: NonNullable<unknown>;
}

export function isExceptionWithOriginalError(exception: unknown): exception is IExceptionWithOriginalError {
  if (typeof exception !== 'object' || exception === null) {
    return false;
  }
  return (exception as { originalError: unknown }).originalError != null;
}

/**
 * @see https://github.com/angular/angular/blob/10.0.0/packages/core/src/util/errors.ts
 */
export interface IExceptionWithNgOriginalError {
  ngOriginalError: NonNullable<unknown>;
}

export function isExceptionWithNgOriginalError(exception: unknown): exception is IExceptionWithNgOriginalError {
  if (typeof exception !== 'object' || exception === null) {
    return false;
  }
  return (exception as { ngOriginalError: unknown }).ngOriginalError != null;
}

export function hasName(value: object): value is { name: string } {
  return typeof (value as { name: unknown }).name === 'string';
}

export function hasMessage(value: object): value is { message: string } {
  return typeof (value as { message: unknown }).message === 'string';
}

export function hasStack(value: object): value is { stack: string } {
  return typeof (value as { stack: unknown }).stack === 'string';
}

export function getErrorDetails(originalError: object): Partial<Error> {
  if (originalError instanceof Error) {
    // NOTE: The error is processed to avoid sending the full stack trace because it can include full
    //       services that can contain sensitive data, the processed version only includes function
    //       calls and file line information.
    return {
      name: originalError.name,
      message: originalError.message,
      stack: originalError.stack && originalError.stack.toString(),
    };
  }
  return {
    name: hasName(originalError) ? originalError.name : undefined,
    message: hasMessage(originalError) ? originalError.message : undefined,
    stack: hasStack(originalError) ? originalError.stack : undefined,
  };
}
